import React, {
    useEffect,
    useState,
} from 'react'

import {
    Button,
    Spin,
    Table,
    Typography,
} from 'antd'

import {
    ReloadOutlined,
    TrophyOutlined,
} from '@ant-design/icons'

import fetch from 'auth/FetchInterceptor'

import {
    OfflineGameService,
} from 'offline'

const {
    Title,
    Text,
} = Typography

const API_BASE_URL =
    'https://games.nlbsolucoes.com/api'

const getImageUrl = (url) => {
    if (!url) {
        return null
    }

    if (
        url.startsWith('http://') ||
        url.startsWith('https://') ||
        url.startsWith('data:')
    ) {
        return url
    }

    return `${API_BASE_URL}${url}`
}

const ResultBox = ({
    label,
    value,
    background,
    textColor,
    borderRadius,
    shadow,
}) => {
    return (
        <div
            style={{
                padding: 18,
                borderRadius:
                    borderRadius ?? 16,
                background:
                    background ||
                    '#ffffff',

                boxShadow:
                    shadow
                        ? '0 10px 30px rgba(0,0,0,.12)'
                        : 'none',
            }}
        >
            <div
                style={{
                    fontSize: 12,
                    fontWeight: 700,
                    letterSpacing: 1,
                    textTransform:
                        'uppercase',
                    color:
                        textColor ||
                        '#111827',

                    opacity:
                        0.62,
                }}
            >
                {label}
            </div>

            <div
                style={{
                    marginTop: 3,
                    color:
                        textColor ||
                        '#111827',
                    fontSize: 28,
                    fontWeight: 900,
                }}
            >
                {value}
            </div>
        </div>
    )
}

const PodiumCard = ({
    item,
    position,
    currentMatchId,
}) => {
    if (!item) {
        return null
    }

    const isCurrent =
        item.id ===
        currentMatchId

    const positionConfig = {
        1: {
            medal:
                '🥇',
            label:
                '1º lugar',
            scale:
                1.08,
        },

        2: {
            medal:
                '🥈',
            label:
                '2º lugar',
            scale:
                1,
        },

        3: {
            medal:
                '🥉',
            label:
                '3º lugar',
            scale:
                1,
        },
    }

    const current =
        positionConfig[
        position
        ] ||
        positionConfig[3]

    return (
        <div
            style={{
                position:
                    'relative',

                flex:
                    '1 1 0',

                minWidth:
                    140,

                padding:
                    '22px 14px',

                borderRadius:
                    20,

                textAlign:
                    'center',

                background:
                    isCurrent
                        ? 'rgba(250,219,20,.22)'
                        : 'rgba(255,255,255,.09)',

                border:
                    isCurrent
                        ? '2px solid #fadb14'
                        : '1px solid rgba(255,255,255,.12)',

                boxShadow:
                    isCurrent
                        ? '0 0 28px rgba(250,219,20,.22)'
                        : 'none',

                transform:
                    `scale(${current.scale})`,

                transition:
                    'all .25s ease',
            }}
        >
            {isCurrent && (
                <div
                    style={{
                        position:
                            'absolute',

                        top:
                            -11,

                        left:
                            '50%',

                        transform:
                            'translateX(-50%)',

                        padding:
                            '4px 10px',

                        borderRadius:
                            999,

                        background:
                            '#fadb14',

                        color:
                            '#000',

                        fontSize:
                            11,

                        fontWeight:
                            900,

                        whiteSpace:
                            'nowrap',
                    }}
                >
                    VOCÊ
                </div>
            )}

            <div
                style={{
                    fontSize:
                        42,

                    lineHeight:
                        1,
                }}
            >
                {
                    current.medal
                }
            </div>

            <div
                style={{
                    marginTop:
                        8,

                    color:
                        'rgba(255,255,255,.60)',

                    fontSize:
                        12,

                    fontWeight:
                        800,

                    textTransform:
                        'uppercase',

                    letterSpacing:
                        1,
                }}
            >
                {
                    current.label
                }
            </div>

            <div
                style={{
                    marginTop:
                        8,

                    color:
                        '#ffffff',

                    fontSize:
                        18,

                    fontWeight:
                        900,

                    overflow:
                        'hidden',

                    textOverflow:
                        'ellipsis',

                    whiteSpace:
                        'nowrap',
                }}
            >
                {
                    item
                        ?.participant
                        ?.name ||
                    'Participante'
                }
            </div>

            <div
                style={{
                    marginTop:
                        6,

                    color:
                        '#fadb14',

                    fontSize:
                        25,

                    fontWeight:
                        1000,
                }}
            >
                {
                    Number(
                        item?.score ||
                        0,
                    )
                }
            </div>

            <div
                style={{
                    marginTop:
                        2,

                    color:
                        'rgba(255,255,255,.55)',

                    fontSize:
                        11,

                    fontWeight:
                        700,
                }}
            >
                PONTOS
            </div>
        </div>
    )
}

const MemoryResult = ({
    game,
    match,
    onContinue,
    redirecting = false,
}) => {
    // ======================================================
    // CONFIGURAÇÃO VISUAL DO RESULTADO
    // ======================================================

    const [
        config,
        setConfig,
    ] = useState(null)

    const isOfflineMatch =
        match?.offline === true ||
        String(
            match?.id ||
            '',
        ).startsWith(
            'offline-memory-',
        ) ||
        String(
            match?.localId ||
            '',
        ).startsWith(
            'offline-memory-',
        )

    // ======================================================
    // CARREGAR CONFIGURAÇÃO DO MEMORY
    // ======================================================

    useEffect(() => {
        let mounted =
            true

        const loadConfig =
            async () => {
                if (
                    !game?.id
                ) {
                    if (
                        mounted
                    ) {
                        setConfig(
                            null,
                        )

                        setLoadingConfig(
                            false,
                        )

                        setConfigLoaded(
                            true,
                        )
                    }

                    return
                }

                try {
                    setLoadingConfig(
                        true,
                    )

                    setConfigLoaded(
                        false,
                    )

                    let result =
                        null

                    // ==========================================
                    // 1. PARTIDA OFFLINE
                    // INDEXEDDB PRIMEIRO
                    // ==========================================

                    if (
                        isOfflineMatch
                    ) {
                        try {
                            result =
                                await OfflineGameService
                                    .getMemoryConfig(
                                        game.id,
                                    )

                            if (
                                result
                            ) {
                                console.log(
                                    '[MEMORY RESULT] Configuração carregada do IndexedDB.',
                                )
                            }
                        } catch (
                        offlineError
                        ) {
                            console.error(
                                '[MEMORY RESULT] Erro ao ler configuração offline:',
                                offlineError,
                            )
                        }
                    }

                    // ==========================================
                    // 2. PARTIDA ONLINE
                    // API PRIMEIRO
                    // ==========================================

                    if (
                        !result &&
                        !isOfflineMatch
                    ) {
                        try {
                            result =
                                await fetch({
                                    url:
                                        `/memory-games/${game.id}`,

                                    method:
                                        'get',

                                    silentNetworkError:
                                        true,
                                })

                            if (
                                result
                            ) {
                                try {
                                    await OfflineGameService
                                        .saveMemoryConfig(
                                            game.id,
                                            result,
                                        )

                                    console.log(
                                        '[MEMORY RESULT] Configuração online atualizada no IndexedDB.',
                                    )
                                } catch (
                                cacheError
                                ) {
                                    console.warn(
                                        '[MEMORY RESULT] Não foi possível atualizar snapshot:',
                                        cacheError,
                                    )
                                }
                            }
                        } catch (
                        apiError
                        ) {
                            console.warn(
                                '[MEMORY RESULT] API indisponível. Tentando IndexedDB...',
                                apiError,
                            )
                        }
                    }

                    // ==========================================
                    // 3. FALLBACK INDEXEDDB
                    // ==========================================

                    if (
                        !result
                    ) {
                        try {
                            result =
                                await OfflineGameService
                                    .getMemoryConfig(
                                        game.id,
                                    )

                            if (
                                result
                            ) {
                                console.log(
                                    '[MEMORY RESULT] Configuração recuperada pelo fallback offline.',
                                )
                            }
                        } catch (
                        offlineError
                        ) {
                            console.error(
                                '[MEMORY RESULT] Falha no fallback IndexedDB:',
                                offlineError,
                            )
                        }
                    }

                    if (
                        !mounted
                    ) {
                        return
                    }

                    setConfig(
                        result?.config ||
                        null,
                    )
                } catch (
                error
                ) {
                    console.error(
                        '[MEMORY RESULT] Erro ao carregar configuração:',
                        error,
                    )

                    if (
                        mounted
                    ) {
                        setConfig(
                            null,
                        )
                    }
                } finally {
                    if (
                        mounted
                    ) {
                        setLoadingConfig(
                            false,
                        )

                        setConfigLoaded(
                            true,
                        )
                    }
                }
            }

        loadConfig()

        return () => {
            mounted =
                false
        }
    }, [
        game?.id,
        isOfflineMatch,
    ])

    const [
        loadingConfig,
        setLoadingConfig,
    ] = useState(true)

    const [
        configLoaded,
        setConfigLoaded,
    ] = useState(false)

    const [
        ranking,
        setRanking,
    ] = useState([])

    const [
        loadingRanking,
        setLoadingRanking,
    ] = useState(false)

    const [
        rankingPosition,
        setRankingPosition,
    ] = useState(null)


    useEffect(() => {
        let mounted =
            true

        const loadRanking =
            async () => {
                if (
                    !game?.id ||
                    !configLoaded
                ) {
                    return
                }
                if (
                    config?.resultImageOnly ===
                    true
                ) {
                    if (
                        mounted
                    ) {
                        setRanking([])
                        setRankingPosition(null)
                        setLoadingRanking(false)
                    }

                    return
                }

                /*
                 * Partidas offline ainda não possuem
                 * posição no ranking do servidor.
                 */
                if (
                    isOfflineMatch
                ) {
                    if (
                        mounted
                    ) {
                        setRanking(
                            [],
                        )

                        setRankingPosition(
                            null,
                        )

                        setLoadingRanking(
                            false,
                        )
                    }

                    return
                }

                try {
                    setLoadingRanking(
                        true,
                    )

                    const result =
                        await fetch({
                            url:
                                `/memory-games/${game.id}/ranking?limit=${Math.max(
                                    3,
                                    Number(
                                        config?.resultRankingLimit ??
                                        5,
                                    ),
                                )}`,

                            method:
                                'get',

                            silentNetworkError:
                                true,
                        })

                    // ==========================================
                    // BUSCAR POSIÇÃO REAL DO PARTICIPANTE
                    // ==========================================

                    const positionResult =
                        match?.id
                            ? await fetch({
                                url:
                                    `/memory-games/${game.id}/ranking-position/${match.id}`,

                                method:
                                    'get',

                                silentNetworkError:
                                    true,
                            })
                            : null

                    if (!mounted) {
                        return
                    }

                    setRanking(
                        Array.isArray(
                            result,
                        )
                            ? result
                            : result?.items ||
                            result?.data ||
                            [],
                    )
                    setRankingPosition(
                        positionResult?.position ??
                        null,
                    )
                } catch (error) {
                    console.error(
                        '[MEMORY RESULT] Erro ao carregar ranking:',
                        error,
                    )

                    if (
                        mounted
                    ) {
                        setRanking([])
                    }
                } finally {
                    if (
                        mounted
                    ) {
                        setLoadingRanking(
                            false,
                        )
                    }
                }
            }

        loadRanking()

        return () => {
            mounted =
                false
        }
    },
        [
            game?.id,
            match?.id,
            configLoaded,
            config?.resultRankingLimit,
            config?.resultImageOnly,
            isOfflineMatch,
        ])

    // ======================================================
    // PERSONALIZAÇÃO DA TELA DE RESULTADO
    // ======================================================

    const resultImageOnly =
        config?.resultImageOnly ===
        true

    const resultCompletedImageUrl =
        config?.resultCompletedImageUrl ||
        null

    const resultTimeoutImageUrl =
        config?.resultTimeoutImageUrl ||
        null

    const resultShowBackButton =
        config?.resultShowBackButton !==
        false

    const resultBackgroundUrl =
        config?.resultBackgroundUrl ||
        game?.backgroundUrl ||
        null

    const resultBackgroundColor =
        config?.resultBackgroundColor ||
        game?.backgroundColor ||
        '#061a40'

    const resultLogoUrl =
        config?.resultLogoUrl ||
        game?.logoUrl ||
        null

    const resultShowLogo =
        config?.resultShowLogo !== false

    const resultLogoWidth =
        Number(
            config?.resultLogoWidth ??
            180,
        )

    const resultLogoHeight =
        Number(
            config?.resultLogoHeight ??
            100,
        )

    const resultCompletedTitle =
        config?.resultCompletedTitle ||
        'PARABÉNS!'

    const resultTimeoutTitle =
        config?.resultTimeoutTitle ||
        'TEMPO ESGOTADO!'

    const resultSubtitle =
        config?.resultSubtitle ||
        'Confira seu resultado'

    const resultTitleColor =
        config?.resultTitleColor ||
        '#0d3f9f'

    const resultTitleFontSize =
        Number(
            config?.resultTitleFontSize ??
            64,
        )

    const resultTextColor =
        config?.resultTextColor ||
        game?.textColor ||
        '#111827'

    const resultPrimaryColor =
        config?.resultPrimaryColor ||
        game?.primaryColor ||
        '#1677ff'

    const resultCardBackground =
        config?.resultCardBackground ||
        '#ffffff'

    const resultCardTextColor =
        config?.resultCardTextColor ||
        '#111827'

    const resultCardBorderRadius =
        Number(
            config?.resultCardBorderRadius ??
            24,
        )

    const resultCardShadow =
        config?.resultCardShadow !== false

    const resultShowScore =
        config?.resultShowScore !== false

    const resultShowTime =
        config?.resultShowTime !== false

    const resultShowAttempts =
        config?.resultShowAttempts !== false

    const resultShowErrors =
        config?.resultShowErrors !== false

    const resultShowRanking =
        config?.resultShowRanking !== false

    const resultRankingTitle =
        config?.resultRankingTitle ||
        'RANKING'


    const resultButtonText =
        config?.resultButtonText ||
        'PRÓXIMO PARTICIPANTE'

    const resultButtonColor =
        config?.resultButtonColor ||
        resultPrimaryColor

    const resultButtonTextColor =
        config?.resultButtonTextColor ||
        '#ffffff'

    const resultExternalRedirectEnabled =
        config?.resultExternalRedirectEnabled ===
        true

    const resultExternalRedirectUrl =
        config?.resultExternalRedirectUrl ||
        ''

    const resultExternalButtonText =
        config?.resultExternalButtonText ||
        'ACESSAR'

    const resultExternalOpenNewTab =
        config?.resultExternalOpenNewTab ===
        true

    console.log(
        '[MEMORY RESULT CONFIG]',
        {
            resultImageOnly:
                config?.resultImageOnly,

            resultCompletedImageUrl:
                config?.resultCompletedImageUrl,

            resultTimeoutImageUrl:
                config?.resultTimeoutImageUrl,

            resultShowBackButton:
                config?.resultShowBackButton,

            completed:
                match?.completed,
        },
    )

    const completed =
        match?.completed === true

    const resultFullImageUrl =
        completed
            ? resultCompletedImageUrl
            : resultTimeoutImageUrl

    const score =
        Number(
            match?.score || 0,
        )

    const prizeName =
        match?.prizeName ||
        match?.prize?.name ||
        null

    const prizeImageUrl =
        match?.prizeImageUrl ||
        match?.prize?.imageUrl ||
        null

    const hasPrize =
        Boolean(
            match?.prizeId ||
            prizeName ||
            prizeImageUrl,
        )

    const attempts =
        Number(
            match?.attempts || 0,
        )

    const errors =
        Number(
            match?.errors || 0,
        )

    const durationMs =
        Number(
            match?.durationMs || 0,
        )

    const fallbackPosition =
        ranking.findIndex(
            (item) =>
                item.id ===
                match?.id,
        ) + 1

    const currentPosition =
        rankingPosition ||
        fallbackPosition ||
        0

    const topThree =
        ranking.slice(
            0,
            3,
        )

    const podiumItems = [
        {
            item:
                topThree[1],
            position:
                2,
        },

        {
            item:
                topThree[0],
            position:
                1,
        },

        {
            item:
                topThree[2],
            position:
                3,
        },
    ]

    const remainingRanking =
        ranking.slice(
            3,
        )

    const getParticipantName =
        (rankingItem) => {
            return (
                rankingItem
                    ?.participant
                    ?.name ||
                'Participante'
            )
        }

    const rankingColumns = [
        {
            title:
                '#',

            width:
                50,

            render:
                (
                    _,
                    record,
                    index,
                ) =>
                    index + 4,
        },

        {
            title:
                'Participante',

            render:
                (
                    _,
                    record,
                ) => {
                    const isCurrent =
                        record.id ===
                        match?.id

                    return (
                        <div>
                            <span>
                                {
                                    getParticipantName(
                                        record,
                                    )
                                }
                            </span>

                            {isCurrent && (
                                <span
                                    style={{
                                        marginLeft:
                                            8,

                                        padding:
                                            '2px 7px',

                                        borderRadius:
                                            999,

                                        background:
                                            '#fadb14',

                                        color:
                                            '#000',

                                        fontSize:
                                            10,

                                        fontWeight:
                                            900,
                                    }}
                                >
                                    VOCÊ
                                </span>
                            )}
                        </div>
                    )
                },
        },

        {
            title:
                'Pontos',

            dataIndex:
                'score',

            width:
                90,

            render:
                (value) => (
                    <strong>
                        {
                            Number(
                                value ||
                                0,
                            )
                        }
                    </strong>
                ),
        },
    ]

    const handleResultButtonClick =
        () => {
            if (
                resultExternalRedirectEnabled &&
                resultExternalRedirectUrl
            ) {
                if (
                    resultExternalOpenNewTab
                ) {
                    window.open(
                        resultExternalRedirectUrl,
                        '_blank',
                        'noopener,noreferrer',
                    )

                    return
                }

                window.location.href =
                    resultExternalRedirectUrl

                return
            }

            if (
                typeof onContinue ===
                'function'
            ) {
                onContinue()
            }
        }

    // ======================================================
    // CARREGANDO CONFIGURAÇÃO
    // ======================================================

    if (
        loadingConfig
    ) {
        return (
            <div
                style={{
                    width:
                        '100vw',

                    height:
                        '100vh',

                    display:
                        'flex',

                    alignItems:
                        'center',

                    justifyContent:
                        'center',

                    backgroundColor:
                        game?.backgroundColor ||
                        '#061a40',
                }}
            >
                <Spin
                    size="large"
                />
            </div>
        )
    }

    // ======================================================
    // MODO SOMENTE ARTE
    // ======================================================

    if (
        resultImageOnly &&
        resultFullImageUrl
    ) {
        return (
            <div
                style={{
                    position:
                        'relative',

                    width:
                        '100vw',

                    height:
                        '100vh',

                    overflow:
                        'hidden',

                    backgroundColor:
                        resultBackgroundColor,

                    backgroundImage:
                        `url(${getImageUrl(
                            resultFullImageUrl,
                        )})`,

                    backgroundSize:
                        'cover',

                    backgroundPosition:
                        'center',

                    backgroundRepeat:
                        'no-repeat',
                }}
            >
                {resultShowBackButton && (
                    <Button
                        type="primary"
                        size="large"
                        loading={
                            redirecting
                        }
                        onClick={
                            handleResultButtonClick
                        }
                        style={{
                            position:
                                'absolute',

                            left:
                                '50%',

                            bottom:
                                70,

                            transform:
                                'translateX(-50%)',

                            minWidth:
                                300,

                            height:
                                60,

                            padding:
                                '0 34px',

                            fontSize:
                                18,

                            fontWeight:
                                900,

                            background:
                                resultButtonColor,

                            borderColor:
                                resultButtonColor,

                            color:
                                resultButtonTextColor,

                            borderRadius:
                                14,

                            zIndex:
                                20,
                        }}
                    >
                        {resultExternalRedirectEnabled
                            ? resultExternalButtonText
                            : resultButtonText}
                    </Button>
                )}
            </div>
        )
    }

    return (
        <div
            style={{
                width: '100vw',
                minHeight: '100vh',

                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',

                padding: 24,

                boxSizing:
                    'border-box',

                backgroundColor:
                    resultBackgroundColor,

                backgroundImage:
                    resultBackgroundUrl
                        ? `url(${getImageUrl(
                            resultBackgroundUrl,
                        )})`
                        : undefined,

                backgroundSize:
                    'cover',

                backgroundPosition:
                    'center',

                color:
                    resultTextColor,
            }}
        >
            <style>
                {`
        .memory-result-ranking
        .ant-table {
            background: transparent;
        }

        .memory-result-ranking
        .ant-table-container {
            border-radius: 12px;
            overflow: hidden;
        }

        .memory-result-ranking
        .memory-current-ranking-row
        > td {
            background:
                rgba(250, 219, 20, .18)
                !important;

            color:
                #000;
        }

        .memory-result-ranking
        .memory-current-ranking-row
        > td:first-child {
            border-left:
                4px solid #fadb14;
        }
    `}
            </style>
            <div
                style={{
                    width:
                        'min(1100px, 100%)',

                    margin:
                        '0 auto',

                    textAlign:
                        'center',

                    color:
                        resultTextColor,
                }}
            >
                {resultShowLogo &&
                    resultLogoUrl && (
                        <div
                            style={{
                                marginBottom:
                                    22,
                            }}
                        >
                            <img
                                src={getImageUrl(
                                    resultLogoUrl,
                                )}
                                alt="Logo"
                                draggable={false}
                                style={{
                                    width:
                                        resultLogoWidth,

                                    maxWidth:
                                        '80vw',

                                    height:
                                        'auto',

                                    maxHeight:
                                        resultLogoHeight,

                                    objectFit:
                                        'contain',
                                }}
                            />
                        </div>
                    )}

                <TrophyOutlined
                    style={{
                        fontSize: 72,

                        marginBottom:
                            20,

                        color: completed
                            ? '#fadb14'
                            : '#ff7875',
                    }}
                />

                <Title
                    level={1}
                    style={{
                        margin:
                            '0 0 8px',

                        color:
                            resultTitleColor,

                        fontSize:
                            resultTitleFontSize,

                        lineHeight:
                            1.05,

                        fontWeight:
                            900,
                    }}
                >
                    {completed
                        ? resultCompletedTitle
                        : resultTimeoutTitle}
                </Title>

                <Text
                    style={{
                        display:
                            'block',

                        color:
                            resultTextColor,

                        fontSize:
                            18,

                        opacity:
                            0.82,
                    }}
                >
                    {resultSubtitle}
                </Text>

                {/* ====================================================== */}
                {/* BRINDE GANHO */}
                {/* ====================================================== */}

                {hasPrize && (
                    <div
                        style={{
                            width:
                                'min(520px, 100%)',

                            margin:
                                '28px auto 0',

                            padding:
                                '26px 24px',

                            borderRadius:
                                24,

                            background:
                                'rgba(255,255,255,.96)',

                            boxShadow:
                                '0 14px 40px rgba(0,0,0,.18)',

                            textAlign:
                                'center',

                            boxSizing:
                                'border-box',
                        }}
                    >
                        <div
                            style={{
                                color:
                                    resultPrimaryColor,

                                fontSize:
                                    16,

                                fontWeight:
                                    900,

                                textTransform:
                                    'uppercase',

                                letterSpacing:
                                    1.5,

                                marginBottom:
                                    14,
                            }}
                        >
                            🎁 Você ganhou!
                        </div>

                        {prizeImageUrl && (
                            <div
                                style={{
                                    width:
                                        '100%',

                                    height:
                                        220,

                                    display:
                                        'flex',

                                    alignItems:
                                        'center',

                                    justifyContent:
                                        'center',

                                    marginBottom:
                                        16,
                                }}
                            >
                                <img
                                    src={
                                        getImageUrl(
                                            prizeImageUrl,
                                        )
                                    }
                                    alt={
                                        prizeName ||
                                        'Brinde'
                                    }
                                    draggable={
                                        false
                                    }
                                    style={{
                                        maxWidth:
                                            '100%',

                                        maxHeight:
                                            210,

                                        objectFit:
                                            'contain',

                                        filter:
                                            'drop-shadow(0 10px 16px rgba(0,0,0,.16))',
                                    }}
                                />
                            </div>
                        )}

                        <div
                            style={{
                                color:
                                    '#111827',

                                fontSize:
                                    30,

                                lineHeight:
                                    1.1,

                                fontWeight:
                                    900,
                            }}
                        >
                            {prizeName ||
                                'Brinde'}
                        </div>

                        <div
                            style={{
                                marginTop:
                                    8,

                                color:
                                    '#6b7280',

                                fontSize:
                                    15,

                                fontWeight:
                                    600,
                            }}
                        >
                            Procure nossa equipe para retirar seu prêmio.
                        </div>
                    </div>
                )}

                {completed &&
                    currentPosition >
                    0 && (
                        <div
                            style={{
                                display:
                                    'inline-block',

                                marginTop:
                                    18,

                                padding:
                                    '9px 18px',

                                borderRadius:
                                    999,

                                background:
                                    'rgba(250,219,20,.16)',

                                border:
                                    '1px solid rgba(250,219,20,.45)',

                                color:
                                    '#fadb14',

                                fontSize:
                                    20,

                                fontWeight:
                                    900,
                            }}
                        >
                            Você está em{' '}
                            {
                                currentPosition
                            }
                            º lugar!
                        </div>
                    )}

                {completed &&
                    currentPosition >
                    10 && (
                        <div
                            style={{
                                marginTop:
                                    10,

                                color:
                                    'rgba(255,255,255,.65)',

                                fontSize:
                                    14,
                            }}
                        >
                            Continue tentando para entrar no Top 10.
                        </div>
                    )}

                <div
                    style={{
                        display: 'grid',

                        gridTemplateColumns:
                            'repeat(2, minmax(0, 1fr))',

                        gap: 14,

                        marginTop: 32,
                    }}
                >
                    {resultShowScore && (
                        <ResultBox
                            label="Pontuação"
                            value={score}
                            background={
                                resultCardBackground
                            }
                            textColor={
                                resultCardTextColor
                            }
                            borderRadius={
                                resultCardBorderRadius
                            }
                            shadow={
                                resultCardShadow
                            }
                        />
                    )}

                    {resultShowAttempts && (
                        <ResultBox
                            label="Tentativas"
                            value={attempts}
                            background={
                                resultCardBackground
                            }
                            textColor={
                                resultCardTextColor
                            }
                            borderRadius={
                                resultCardBorderRadius
                            }
                            shadow={
                                resultCardShadow
                            }
                        />
                    )}

                    {resultShowErrors && (
                        <ResultBox
                            label="Erros"
                            value={errors}
                            background={
                                resultCardBackground
                            }
                            textColor={
                                resultCardTextColor
                            }
                            borderRadius={
                                resultCardBorderRadius
                            }
                            shadow={
                                resultCardShadow
                            }
                        />
                    )}

                    {resultShowTime && (
                        <ResultBox
                            label="Tempo"
                            value={`${(
                                durationMs /
                                1000
                            ).toFixed(1)}s`}
                            background={
                                resultCardBackground
                            }
                            textColor={
                                resultCardTextColor
                            }
                            borderRadius={
                                resultCardBorderRadius
                            }
                            shadow={
                                resultCardShadow
                            }
                        />
                    )}
                </div>


                {resultShowRanking && (
                    <div
                        style={{
                            marginTop:
                                30,

                            paddingTop:
                                24,

                            borderTop:
                                '1px solid rgba(255,255,255,.14)',
                        }}
                    >
                        <div
                            style={{
                                marginBottom:
                                    22,

                                color:
                                    '#ffffff',

                                fontSize:
                                    22,

                                fontWeight:
                                    900,
                            }}
                        >
                            {resultRankingTitle}
                        </div>

                        {loadingRanking ? (
                            <div
                                style={{
                                    padding:
                                        24,

                                    textAlign:
                                        'center',
                                }}
                            >
                                <Spin />
                            </div>
                        ) : ranking.length ===
                            0 ? (
                            <div
                                style={{
                                    padding:
                                        20,

                                    color:
                                        'rgba(255,255,255,.65)',
                                }}
                            >
                                {isOfflineMatch
                                    ? 'Resultado salvo offline. O ranking será atualizado quando a conexão voltar.'
                                    : 'Ranking ainda sem participantes.'}
                            </div>
                        ) : (
                            <>
                                {/* ====================================== */}
                                {/* PÓDIO */}
                                {/* ====================================== */}

                                <div
                                    style={{
                                        display:
                                            'flex',

                                        alignItems:
                                            'flex-end',

                                        justifyContent:
                                            'center',

                                        gap:
                                            12,

                                        marginBottom:
                                            26,
                                    }}
                                >
                                    {podiumItems.map(
                                        ({
                                            item,
                                            position,
                                        }) =>
                                            item ? (
                                                <PodiumCard
                                                    key={
                                                        item.id
                                                    }
                                                    item={
                                                        item
                                                    }
                                                    position={
                                                        position
                                                    }
                                                    currentMatchId={
                                                        match?.id
                                                    }
                                                />
                                            ) : null,
                                    )}
                                </div>

                                {/* ====================================== */}
                                {/* RESTANTE DO RANKING */}
                                {/* ====================================== */}

                                {remainingRanking.length >
                                    0 && (
                                        <div
                                            className="memory-result-ranking"
                                            style={{
                                                marginTop:
                                                    14,
                                            }}
                                        >
                                            <Table
                                                rowKey="id"
                                                columns={
                                                    rankingColumns
                                                }
                                                dataSource={
                                                    remainingRanking
                                                }
                                                pagination={
                                                    false
                                                }
                                                size="small"
                                                rowClassName={(
                                                    record,
                                                ) =>
                                                    record.id ===
                                                        match?.id
                                                        ? 'memory-current-ranking-row'
                                                        : ''
                                                }
                                            />
                                        </div>
                                    )}
                            </>
                        )}
                    </div>
                )}

                <Button
                    type="primary"
                    size="large"
                    icon={
                        <ReloadOutlined />
                    }
                    loading={
                        redirecting
                    }
                    onClick={
                        handleResultButtonClick
                    }

                    style={{
                        marginTop:
                            32,

                        minWidth:
                            300,

                        height:
                            60,

                        padding:
                            '0 34px',

                        fontSize:
                            18,

                        fontWeight:
                            900,

                        background:
                            resultButtonColor,

                        borderColor:
                            resultButtonColor,

                        color:
                            resultButtonTextColor,

                        borderRadius:
                            14,
                    }}
                >
                    {resultExternalRedirectEnabled
                        ? resultExternalButtonText
                        : resultButtonText}
                </Button>
            </div>
        </div >
    )
}

export default MemoryResult